import { createSlice } from "@reduxjs/toolkit";

import { teleopActions } from "state/teleop/slice";

import type { PayloadAction } from "@reduxjs/toolkit";
import type { ChannelSettings } from "@skydio/pbtypes/pbtypes/gen/qca_stats/channel_settings_pb";

export interface WifiChannelSettingsState {
  channelSettings: ChannelSettings.AsObject | null;
}

const initialState: WifiChannelSettingsState = {
  channelSettings: null,
};

const { reducer, actions: wifiChannelSettingsActions } = createSlice({
  name: "wifiChannelSettings",
  initialState,
  reducers: {
    handleChannelSettings(state, { payload }: PayloadAction<ChannelSettings.AsObject>) {
      state.channelSettings = payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(teleopActions.updateTeleopSessionId, () => {
      // Clear state when we get a new teleop session ID
      return { ...initialState };
    });
  },
});

export default reducer;
export { wifiChannelSettingsActions };
